import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  Modal,
  HeadingDisplay,
  HelperViewStatus,
  ContentDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import { ContentDisplayLoader } from '@/modules/trade/components/ContentDisplayLoader';
import { ListDisplayLoader } from '@/modules/trade/components/ListDisplayLoader';

import { AvailableBalanceData } from '@/modules/trade/services/unified-account/types';

interface Props {
  isOpen: boolean;
  error: boolean;
  loading: boolean;
  availableBalanceData: AvailableBalanceData | null;
}
interface Emits {
  'on-close': () => void;
  'on-retry': () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AvailableBalanceModal',
  props: {
    isOpen: { type: Boolean },
    error: { type: Boolean },
    loading: { type: Boolean },
    availableBalanceData: null
  },
  setup(__props: any, { emit }: { emit: ({
  'on-close': () => void;
  'on-retry': () => void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  error: boolean;
  loading: boolean;
  availableBalanceData: AvailableBalanceData | null;
};





const availableOnAccountValueFormatted = computed(() => {
  return props.availableBalanceData?.availableOnAccountValue?.formatted || '-';
});

const availableToSettleValue = computed(() => {
  return props.availableBalanceData?.toSettleValue?.formatted || '-';
});

const availableToOperateValue = computed(() => {
  return props.availableBalanceData?.availableToOperateValue?.formatted || '-';
});

const handleClose = () => {
  emit('on-close');
};

const handleRetry = () => {
  emit('on-retry');
};

return { __sfc: true,props, emit, availableOnAccountValueFormatted, availableToSettleValue, availableToOperateValue, handleClose, handleRetry, Modal, HeadingDisplay, HelperViewStatus, ContentDisplay, ListDisplay, ContentDisplayLoader, ListDisplayLoader }
}

})